import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlSadliersCrossingPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["sadliers-crossing"]} />;
}
